import { api } from '@fastcampus/browser-support';

export default {
  async getUser() {
    try {
      return api.get('/www/users/myinfo?t=' + Date.now(), {
        headers: { 'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate' },
      });
    } catch (err) {
      return new Error(err);
    }
  },
};
